import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./switchSitesButton.module.css";
import React, { useState } from "react";
import { useGetTokenForTherapistMutation } from "../../services/api/auth.api";
import Modal from "../modals/modal/Modal";
import ErrorPopup from "../modals/errorPopup/errorPopup";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";

const ALLOWED_HANDOFFS: Record<string, string> = {
  "admin.bpreven.com": "therapist.bpreven.com",
  "therapist.bpreven.com": "admin.bpreven.com",
  "admin-test.bpreven.com": "therapist-test.bpreven.com",
  "therapist-test.bpreven.com": "admin-test.bpreven.com",
  "localhost:3000": "localhost:3001",
  "localhost:3001": "localhost:3000",
};

function SwitchSitesButton() {
  const admin = useAppSelector(adminSelector);

  const [error, setError] = useState<string | undefined>(undefined);

  const [getTokenForTherapist] = useGetTokenForTherapistMutation();
  const goToOtherSite = async () => {
    // Open the window synchronously before any await so Safari iOS honours
    // the user-gesture context and does not block the popup.
    const newWindow = window.open("", "_blank");

    const res = await getTokenForTherapist();
    if (res && "data" in res && res.data?.success) {
      const { code } = res.data;
      const targetHost = ALLOWED_HANDOFFS[window.location.host];

      if (!targetHost) {
        newWindow?.close();
        setError(t("USER_NOT_FOUND"));
        return;
      }

      const scheme = targetHost.startsWith("localhost") ? "http" : "https";
      const locale = localStorage.getItem("i18nextLng");

      let targetUrl = `${scheme}://${targetHost}/auth/sso#code=${encodeURIComponent(code)}`;
      if (locale) {
        targetUrl += `&lang=${encodeURIComponent(locale)}`;
      }

      if (newWindow) {
        newWindow.location.href = targetUrl;
      }
    } else {
      newWindow?.close();
      setError(
        // @ts-ignore
        "error" in res && res.error?.data
          ? // @ts-ignore
            res.error?.data
          : t('USER_NOT_FOUND')
      );
    }
  };

  return (
    <>
      <button className={styles.button} type={"button"} onClick={goToOtherSite}>
        {t('TO_THE_CAREGIVERS_AREA')}</button>

      {error && (
        <Modal onClose={() => setError(undefined)}>
          <ErrorPopup onClose={() => setError(undefined)} text={error} />
        </Modal>
      )}
    </>
  );
}

export default SwitchSitesButton;
